import { Form, InputNumber, Modal, Select } from '@maxtropy/components';
import { useEffect, useState } from 'react';
import { loadAssetOptions } from './constants';
import { LoadSideParamRecord } from './types';

interface EditLoadSideParamModalProps {
  open: boolean;
  record?: LoadSideParamRecord;
  onCancel: () => void;
  onOk: (values: LoadSideParamRecord) => void;
}

const numberRules = [{ required: true, message: '请输入' }];
const numberInputProps = {
  min: 0,
  max: 99999999.99,
  precision: 2,
  style: { width: '100%' },
};

const EditLoadSideParamModal = (props: EditLoadSideParamModalProps) => {
  const { open, record, onCancel, onOk } = props;
  const [form] = Form.useForm<LoadSideParamRecord>();
  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    if (open && record) {
      form.setFieldsValue(record);
    }
  }, [form, open, record]);

  const handleOk = async () => {
    setConfirmLoading(true);
    const values = await form.validateFields().then(res => res);
    setConfirmLoading(false);

    if (!values || !record) {
      return;
    }

    onOk({
      ...record,
      ...values,
    });
  };

  return (
    <Modal
      title="编辑"
      open={open}
      width={560}
      contentClassName="modal-form-content"
      destroyOnClose
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      onOk={handleOk}
    >
      <Form form={form} layout="horizontal" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
        <Form.Item label="最低运行负荷" name="minRunningLoad" rules={numberRules}>
          <InputNumber placeholder="请输入" addonAfter="MW" {...numberInputProps} />
        </Form.Item>
        <Form.Item label="最长低负荷运行时间" name="maxLowLoadRunningHour" rules={numberRules}>
          <InputNumber placeholder="请输入" addonAfter="h" {...numberInputProps} />
        </Form.Item>
        <Form.Item label="最快降负荷速率" name="maxLoadDownRate" rules={numberRules}>
          <InputNumber placeholder="请输入" addonAfter="MW/min" {...numberInputProps} />
        </Form.Item>
        <Form.Item label="最快升负荷速率" name="maxLoadUpRate" rules={numberRules}>
          <InputNumber placeholder="请输入" addonAfter="MW/min" {...numberInputProps} />
        </Form.Item>
        <Form.Item label="负荷设备资产信息" name="assetInfo" rules={[{ required: true, message: '请选择' }]}>
          <Select placeholder="请选择" options={loadAssetOptions} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditLoadSideParamModal;
